module.exports = __webpack_public_path__ + "img/freshair.1d81d6ba.png";